"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("header", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("h1", { style: { "margin-top": "0" } }, "Fantino Davide"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("h2", null, "Software Developer")
], -1);
var _hoisted_2 = { id: "main" };
var _hoisted_3 = { id: "rightSide" };
var _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "Architected and developed full-stack software solutions utilizing REST APIs, data modeling, and frontend interfaces.", -1);
var _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1);
var _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "REST APIs, backend-to-backend proxy and data model development. API and code documentation.", -1);
var _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "Development of management website and public website e-commerce.", -1);
var _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "Development of management website and public website.", -1);
var _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "Configuration of a VPS for website hosting", -1);
var _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "Development of the public website.", -1);
var _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Initially developed as a standalone tool for Squad server log analysis, this application provides server statistics, cheat reports, and graph generation. An upcoming update will introduce a SquadJS plugin and a static web page, both currently in closed testing. The project also features a custom Discord client to integrate the latest Discord functionalities. The SquadJS plugin is made user-friendly through Webpack bundling.", -1);
var _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Ascended quickly to a critical technical role, becoming the highest-ranked individual after the company owners. Engineered NetDump, a script that monitors and intelligently dumps network traffic, triggering Discord notifications for unauthorized or malicious activity. Tasked with the comprehensive management of dedicated servers, hosting various game server instances. Routinely interface with datacenter and hosting providers to ensure operational excellence. Leading the initiative for the company's expansion into European markets.", -1);
var _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)("Built with Node.js, Vue.js, and MongoDB, supports game server integrations. The Whitelister tool offers a new way to manage user permissions. Gained traction in the gaming community, used by many since its beta release on 09 Jun 2022. Demo site: "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("a", { href: "https://sqwl.fantinodavide.it/" }, "sqwl.fantinodavide.it"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" (Username: demoadmin, Password: demo). Contact for support or project updates via Discord: "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("a", { href: "https://discord.com/invite/5hfcjNYdCP" }, "discord.com/invite/5hfcjNYdCP"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)(".")
], -1);
var _hoisted_14 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { "aria-hidden": "true" }, "Developed a tool for efficient mission management in the Digital Combat Simulator. The application parses LUA mission files to generate booking tables. It integrates with a community forum database for user authentication and employs MongoDB for data storage. Focused on security, using Argon2 for password encryption. Designed to minimize community leader workload, the tool features automated OTA updates from its GitHub repository.", -1);
var _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { "aria-hidden": "true" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)("A project born to help locating a blind dog in a wide-open area."),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("The main steps have been the hardware choice, the designing and 3D printing of the protective shell, the firmwares development, and the android app development and publishment on the Play Store."),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("A close collaboration with veterinary experts has been extremely important to reduce the sources of disorientation for the blind dog."),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("The system is based on two ESP32 868Mhz devices with a custom-developed firmware. Radio transmissions are based on a custom protocol that offers error detection and message acknowledgment.")
], -1);
var _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" Hardware and Software configuration of the enterprise server HP ProLiant DL380 G7."),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("Set up with the hypervisor Proxmox and configured to work as a NAS, Reverse Proxy and Host for many projects."),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("The kerner of the hypervisor has been patched to unlock the IT HBA mode of the hardware RAID controller HP P410i to take advantage of the software ZFS RAID. ")
], -1);
var __default__ = {
    name: 'App',
    data: function () {
        return {
            dark2: '',
        };
    },
    methods: {
        print: function () {
            window.print();
        },
    },
    created: function () {
        // console.log(this.axios);
    },
};
var section_vue_1 = require("./components/section.vue");
var section_desc_vue_1 = require("./components/section-desc.vue");
var tag_vue_1 = require("./components/tag.vue");
exports.default = (0, vue_1.defineComponent)(__assign(__assign({}, __default__), { setup: function (__props) {
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("aside", null, [
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "info" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "address",
                                    desc: "Viale Vittorio Veneto 13, 12061 Carrú (CN), Piedmont, Italy"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "phone",
                                    desc: "+39 3914639240"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "email",
                                    desc: "fantinodavide02@gmail.com"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "pec",
                                    desc: "fantinodavide@pec.it"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "github",
                                    desc: "https://github.com/fantinodavide"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "curriculum vitae",
                                    desc: "https://cv.fantinodavide.it"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "birthday",
                                    desc: "28 Jan 2002"
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "education" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Higher Education Institute \"G. Vallauri\" Fossano CN",
                                    desc: "Informatics and Telecommunications - Specialization: Informatics",
                                    footer: "2016-2021"
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "skills" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "programming Languages",
                                    desc: "Node.js, JavaScript, TypeScript, HTML, CSS, Bash, C, C#, C++, Python, Go, PHP",
                                    array: ""
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Frameworks",
                                    desc: "NestJS, Vue.js, Angular, JQuery, Express.js, Prisma ORM, Crypto, Argon2, Puppeteer, Axios, Discord.js, Webpack",
                                    array: ""
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "cloud",
                                    desc: "Amazon Web Services,IBM Cloud",
                                    array: ""
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Databases",
                                    desc: "MongoDB, MySQL,SQLite,MariaDB",
                                    array: ""
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "softwares",
                                    desc: "Jira,Postman,Proxmox,Docker,Nginx,Wireshark,TrueNAS,ZFS,RAID,FTP,Fusion 360,CPanel,WHMCS,Bitwarden,Termius",
                                    array: ""
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "expertise" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "years of experience",
                                    desc: "Node.JS=2021,Vue.JS=2022,JavaScript=2019,TypeScript=2022,Bash=2021,HTML CSS=2019,AWS=2023",
                                    array: "",
                                    range: "",
                                    showValue: "",
                                    calcYears: ""
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Operating Systems",
                                    desc: "Linux=5,Windows=5,MacOS=2",
                                    array: "",
                                    range: ""
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "personality" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    desc: "Relationing=4,Strategy=5,Communication=3.5,dedication=5,design=4",
                                    array: "",
                                    range: ""
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "languages" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    desc: "English=4,Italian=5,French=1",
                                    array: "",
                                    range: ""
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "patents" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Authorization for defibrillation with Automatic External Defibrillator",
                                    subt: "July 2021"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Driving License",
                                    desc: "A1,B",
                                    array: ""
                                })
                            ]; }),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "about myself" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, { desc: "IT Specialist committed to implementing the latest technologies to enhance project outcomes and user experience. Skilled in a diverse set of programming languages, my current focus is on NodeJS, Vue.JS, TypeScript, and JavaScript, while learning Go. Actively expanding my network security skills, sampling, analyzing and blocking DDoS attacks." })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "experience" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Sellup",
                                    subt: "Software Developer",
                                    desc: "https://sellup.cloud",
                                    date: "Apr 2023 - Current"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_4,
                                        (0, vue_2.createElementVNode)("p", null, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['NestJS', 'TypeScript', 'Vue.js', 'Angular', 'SQL', 'MongoDB', 'Docker', 'AWS', 'Stripe', 'Prisma ORM', 'Jira', 'Swagger'], function (c) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(tag_vue_1.default, {
                                                    key: c,
                                                    value: c,
                                                    skew: ""
                                                }, null, 8, ["value"]));
                                            }), 128)),
                                            _hoisted_5,
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['AWS', 'S3', 'EC2', 'ECR', 'ECS', 'API Gateway', 'Lambda', 'IAM', 'Terraform', 'Bitbucket'], function (c) {
                                                return (0, vue_2.createVNode)(tag_vue_1.default, {
                                                    key: c,
                                                    value: c,
                                                    skew: ""
                                                }, null, 8, ["value"]);
                                            }), 64))
                                        ])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Sellup",
                                    subt: "Backend Developer Intern",
                                    desc: "https://sellup.cloud",
                                    date: "Nov 2022 - Apr 2023"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_6,
                                        (0, vue_2.createElementVNode)("p", null, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['NestJS', 'TypeScript', 'JavaScript', 'SQL', 'Docker', 'AWS', 'Stripe', 'Express.js', 'Prisma ORM', 'Jira', 'Swagger'], function (c) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(tag_vue_1.default, {
                                                    key: c,
                                                    value: c,
                                                    skew: ""
                                                }, null, 8, ["value"]));
                                            }), 128))
                                        ])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Manfrinato Gioielli",
                                    subt: "Full Stack Web Developer",
                                    desc: "https://manfrinatogioielli.it",
                                    date: "Jul 2019 - Dec 2021"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_7,
                                        (0, vue_2.createElementVNode)("p", null, [
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['HTML', 'CSS', 'JavaScript'], function (c) {
                                                return (0, vue_2.createVNode)(tag_vue_1.default, {
                                                    value: c,
                                                    key: c,
                                                    skew: ""
                                                }, null, 8, ["value"]);
                                            }), 64)),
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['PHP', 'SQL'], function (c) {
                                                return (0, vue_2.createVNode)(tag_vue_1.default, {
                                                    value: c,
                                                    key: c,
                                                    skew: ""
                                                }, null, 8, ["value"]);
                                            }), 64))
                                        ])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Olos Massaggi e Formazione Ayurvedica",
                                    subt: "Full Stack Web Developer",
                                    desc: "https://olostrattamentiolistici.eu",
                                    date: "jan 2017 - Jun 2019"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_8,
                                        _hoisted_9,
                                        (0, vue_2.createElementVNode)("p", null, [
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['HTML', 'CSS', 'JavaScript'], function (c) {
                                                return (0, vue_2.createVNode)(tag_vue_1.default, {
                                                    value: c,
                                                    key: c,
                                                    skew: ""
                                                }, null, 8, ["value"]);
                                            }), 64)),
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['PHP', 'Bash'], function (c) {
                                                return (0, vue_2.createVNode)(tag_vue_1.default, {
                                                    value: c,
                                                    key: c,
                                                    skew: ""
                                                }, null, 8, ["value"]);
                                            }), 64))
                                        ])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Calzolaio Maurizio Calignano",
                                    subt: "Frontend Developer",
                                    desc: "https://www.calzolaiomaurizio.it",
                                    date: "Jun 2016 - Oct 2017"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_10,
                                        (0, vue_2.createElementVNode)("p", null, [
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['HTML', 'CSS', 'JavaScript'], function (c) {
                                                return (0, vue_2.createVNode)(tag_vue_1.default, {
                                                    value: c,
                                                    key: c,
                                                    skew: ""
                                                }, null, 8, ["value"]);
                                            }), 64))
                                        ])
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "projects" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Squad-Log-To-Graph",
                                    desc: "https://github.com/fantinodavide/Squad-Log-To-Graph",
                                    date: "May 2023"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_11
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "PSG-Hosting",
                                    desc: "https://psg-hosting.com",
                                    date: "Feb 2023"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_12
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Whitelister",
                                    desc: "https://github.com/fantinodavide/Squad_Whitelister",
                                    date: "Apr 2022"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_13
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "DCS Mission Booking",
                                    desc: "https://github.com/fantinodavide/DCS_MissionBooking",
                                    date: "Feb 2022"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_14
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "DogTracker",
                                    desc: "https://github.com/fantinodavide/DogTracker",
                                    date: "Aug 2020 - jan 2021"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_15
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Home Server",
                                    date: "Apr 2021"
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        _hoisted_16
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "certifications" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Introduction to Web Development with HTML, CSS, JavaScript",
                                    desc: "IBM",
                                    footer: "Dec 2021"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Introduction to Cloud Computing",
                                    desc: "IBM",
                                    footer: "Dec 2021"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "CCNAv7: Enterprise Networking, Security, and Automation",
                                    desc: "Cisco Networking Academy",
                                    footer: "Jun 2021"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "CCNAv7: Switching, Routing, and Wireless Essentials",
                                    desc: "Cisco Networking Academy",
                                    footer: "Jun 2021"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "Cambridge English Level 1 Certificate in ESOL International",
                                    desc: "Cambridge University Press & Assessment",
                                    footer: "Feb 2021"
                                }),
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    title: "CCNA: Routing and Switching: Introduction to Networks",
                                    desc: "Cisco Networking Academy",
                                    footer: "May 2020"
                                })
                            ]; }),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(section_vue_1.default, { title: "privacy" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(section_desc_vue_1.default, {
                                    subt: "",
                                    desc: "I authorize the processing of my personal data pursuant to Legislative Decree 101/2018 and art. 13 GDPR (EU Regulation 2016/679) for the purposes of personnel research and selection"
                                })
                            ]; }),
                            _: 1
                        })
                    ])
                ]),
                (0, vue_2.createElementVNode)("button", {
                    id: "print",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return (_ctx.print && _ctx.print.apply(_ctx, args));
                        })
                }, "Print")
            ], 64));
        };
    } }));
